import Papa from "papaparse";

export function downloadCsv<T extends object>(
  filename: string,
  rows: T[],
  columns?: string[]
): void {
  if (rows.length === 0) return;

  const csv = Papa.unparse(rows, {
    columns,
    escapeFormulae: true,
  });
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
